export default __webpack_public_path__ + "static/media/brutalenragingstrike3.8227fe4d.png";